module.exports = __webpack_public_path__ + "img/Uhr.87e7d2d0.png";